__turbopack_context__.v({
  "button": "notInterestedsSignUpSection-module-scss-module__5Rlx0W__button",
  "container": "notInterestedsSignUpSection-module-scss-module__5Rlx0W__container",
  "description": "notInterestedsSignUpSection-module-scss-module__5Rlx0W__description",
  "heading": "notInterestedsSignUpSection-module-scss-module__5Rlx0W__heading",
  "signUp": "notInterestedsSignUpSection-module-scss-module__5Rlx0W__signUp",
});
